export default __webpack_public_path__ + "static/media/alfie-sad.de708e8a.png";